/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  GetDashboardDataCheckExecutionsParams,
  GetDashboardDataCheckExecutionsPathParameters,
  TLDashboardDataCheckUpdateRequest,
  TLGetDashboardExecutionsResponse,
  TLHTTPValidationError,
  TLRetryDashboardDataCheckExecutionRequest,
  TLRetryDashboardDataCheckExecutionResponse,
  TLSuccessResponse,
  UpdateDashboardDataCheckPathParameters,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retry Dashboard Data Check Executions
 */
export const retryDashboardDataCheckExecutions = (
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLRetryDashboardDataCheckExecutionResponse>(
    {
      url: `/v2/data-harmonization/dashboard-data-checks/executions/retry`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLRetryDashboardDataCheckExecutionRequest,
      signal,
    },
    options,
  );
};

export const getRetryDashboardDataCheckExecutionsQueryKey = (
  tLRetryDashboardDataCheckExecutionRequest?: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
) => {
  return [
    'POST',
    'v2',
    'data-harmonization',
    'dashboard-data-checks',
    'executions',
    'retry',
    tLRetryDashboardDataCheckExecutionRequest,
  ] as const;
};

export const getRetryDashboardDataCheckExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRetryDashboardDataCheckExecutionsQueryKey(tLRetryDashboardDataCheckExecutionRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>> = ({ signal }) =>
    retryDashboardDataCheckExecutions(tLRetryDashboardDataCheckExecutionRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type RetryDashboardDataCheckExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>
>;
export type RetryDashboardDataCheckExecutionsQueryError = ErrorType<TLHTTPValidationError>;

export function useRetryDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
          TError,
          Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetryDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
          TError,
          Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useRetryDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retry Dashboard Data Check Executions
 */

export function useRetryDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRetryDashboardDataCheckExecutionsQueryOptions(
    tLRetryDashboardDataCheckExecutionRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Retry Dashboard Data Check Executions
 */
export const prefetchRetryDashboardDataCheckExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof retryDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getRetryDashboardDataCheckExecutionsQueryOptions(
    tLRetryDashboardDataCheckExecutionRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Retry Dashboard Data Check Executions
 */
export const invalidateRetryDashboardDataCheckExecutions = async (
  queryClient: QueryClient,
  tLRetryDashboardDataCheckExecutionRequest: BodyType<TLRetryDashboardDataCheckExecutionRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getRetryDashboardDataCheckExecutionsQueryKey(tLRetryDashboardDataCheckExecutionRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Update Dashboard Data Check
 */
export const updateDashboardDataCheck = (
  { dashboardDataCheckId }: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLSuccessResponse>(
    {
      url: `/v2/data-harmonization/dashboard-data-checks/${dashboardDataCheckId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: tLDashboardDataCheckUpdateRequest,
      signal,
    },
    options,
  );
};

export const getUpdateDashboardDataCheckQueryKey = (
  { dashboardDataCheckId }: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest?: BodyType<TLDashboardDataCheckUpdateRequest>,
) => {
  return [
    'PATCH',
    'v2',
    'data-harmonization',
    'dashboard-data-checks',
    dashboardDataCheckId,
    tLDashboardDataCheckUpdateRequest,
  ] as const;
};

export const getUpdateDashboardDataCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof updateDashboardDataCheck>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardDataCheckId }: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDashboardDataCheck>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUpdateDashboardDataCheckQueryKey({ dashboardDataCheckId }, tLDashboardDataCheckUpdateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateDashboardDataCheck>>> = ({ signal }) =>
    updateDashboardDataCheck({ dashboardDataCheckId }, tLDashboardDataCheckUpdateRequest, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: dashboardDataCheckId !== null && dashboardDataCheckId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof updateDashboardDataCheck>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type UpdateDashboardDataCheckQueryResult = NonNullable<Awaited<ReturnType<typeof updateDashboardDataCheck>>>;
export type UpdateDashboardDataCheckQueryError = ErrorType<TLHTTPValidationError>;

export function useUpdateDashboardDataCheck<
  TData = Awaited<ReturnType<typeof updateDashboardDataCheck>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDashboardDataCheck>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateDashboardDataCheck>>,
          TError,
          Awaited<ReturnType<typeof updateDashboardDataCheck>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateDashboardDataCheck<
  TData = Awaited<ReturnType<typeof updateDashboardDataCheck>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDashboardDataCheck>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateDashboardDataCheck>>,
          TError,
          Awaited<ReturnType<typeof updateDashboardDataCheck>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateDashboardDataCheck<
  TData = Awaited<ReturnType<typeof updateDashboardDataCheck>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDashboardDataCheck>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update Dashboard Data Check
 */

export function useUpdateDashboardDataCheck<
  TData = Awaited<ReturnType<typeof updateDashboardDataCheck>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardDataCheckId }: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDashboardDataCheck>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateDashboardDataCheckQueryOptions(
    { dashboardDataCheckId },
    tLDashboardDataCheckUpdateRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update Dashboard Data Check
 */
export const prefetchUpdateDashboardDataCheckQuery = async <
  TData = Awaited<ReturnType<typeof updateDashboardDataCheck>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { dashboardDataCheckId }: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateDashboardDataCheck>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getUpdateDashboardDataCheckQueryOptions(
    { dashboardDataCheckId },
    tLDashboardDataCheckUpdateRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update Dashboard Data Check
 */
export const invalidateUpdateDashboardDataCheck = async (
  queryClient: QueryClient,
  { dashboardDataCheckId }: UpdateDashboardDataCheckPathParameters,
  tLDashboardDataCheckUpdateRequest: BodyType<TLDashboardDataCheckUpdateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getUpdateDashboardDataCheckQueryKey({ dashboardDataCheckId }, tLDashboardDataCheckUpdateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get Dashboard Data Check Executions
 */
export const getDashboardDataCheckExecutions = (
  { dashboardDataCheckId }: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLGetDashboardExecutionsResponse>(
    {
      url: `/v2/data-harmonization/dashboard-data-checks/${dashboardDataCheckId}/executions`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetDashboardDataCheckExecutionsQueryKey = (
  { dashboardDataCheckId }: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
) => {
  return [
    'v2',
    'data-harmonization',
    'dashboard-data-checks',
    dashboardDataCheckId,
    'executions',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDashboardDataCheckExecutionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardDataCheckId }: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardDataCheckExecutionsQueryKey({ dashboardDataCheckId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>> = ({ signal }) =>
    getDashboardDataCheckExecutions({ dashboardDataCheckId }, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: dashboardDataCheckId !== null && dashboardDataCheckId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetDashboardDataCheckExecutionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>
>;
export type GetDashboardDataCheckExecutionsQueryError = ErrorType<TLHTTPValidationError>;

export function useGetDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetDashboardDataCheckExecutionsPathParameters,
  params: undefined | GetDashboardDataCheckExecutionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
          TError,
          Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Dashboard Data Check Executions
 */

export function useGetDashboardDataCheckExecutions<
  TData = Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { dashboardDataCheckId }: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDashboardDataCheckExecutionsQueryOptions({ dashboardDataCheckId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Dashboard Data Check Executions
 */
export const prefetchGetDashboardDataCheckExecutionsQuery = async <
  TData = Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { dashboardDataCheckId }: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardDataCheckExecutions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetDashboardDataCheckExecutionsQueryOptions({ dashboardDataCheckId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Dashboard Data Check Executions
 */
export const invalidateGetDashboardDataCheckExecutions = async (
  queryClient: QueryClient,
  { dashboardDataCheckId }: GetDashboardDataCheckExecutionsPathParameters,
  params?: GetDashboardDataCheckExecutionsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGetDashboardDataCheckExecutionsQueryKey({ dashboardDataCheckId }, params) },
    options,
  );

  return queryClient;
};
